import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  defs,
  linearGradient,
  stop,
} from "recharts";
import { Card } from "@/components/ui/card";
import { BalanceData } from "@/types/transaction";

interface BalanceChartProps {
  data: BalanceData[];
}

export const BalanceChart = ({ data }: BalanceChartProps) => (
  <Card className="p-6 border-slate-200 dark:border-slate-800">
    <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">
      Balance Trend (7 Days)
    </h2>
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
        <defs>
          <linearGradient id="colorBalance" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#06B6D4" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#06B6D4" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
        <XAxis
          dataKey="date"
          tickFormatter={(date) => new Date(date).toLocaleDateString("en-US", {month: "short", day: "numeric"})}
          stroke="#94a3b8"
          style={{ fontSize: "12px" }}
        />
        <YAxis stroke="#94a3b8" style={{ fontSize: "12px" }} />
        <Tooltip
          formatter={(value: number) =>
            `$${value.toLocaleString("en-US", { minimumFractionDigits: 2 })}`
          }
          contentStyle={{
            backgroundColor: "#1e293b",
            border: "1px solid #475569",
            borderRadius: "8px",
          }}
          labelStyle={{ color: "#f1f5f9" }}
        />
        <Line
          type="monotone"
          dataKey="balance"
          stroke="#0891B2"
          strokeWidth={2}
          dot={{ fill: "#0891B2", r: 4 }}
          activeDot={{ r: 6 }}
          fillOpacity={1}
          fill="url(#colorBalance)"
        />
      </LineChart>
    </ResponsiveContainer>
  </Card>
);
